var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscipline4By4Icon = function SvgDiscipline4By4Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 4.017,
    y: 3.933,
    fill: "currentColor",
    rx: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 9.239,
    y: 3.933,
    fill: "currentColor",
    rx: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 14.461,
    y: 3.933,
    fill: "currentColor",
    rx: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 19.683,
    y: 3.933,
    fill: "currentColor",
    rx: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 4.017,
    y: 9.211,
    fill: "currentColor",
    rx: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 9.239,
    y: 9.211,
    fill: "currentColor",
    rx: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 14.461,
    y: 9.211,
    fill: "currentColor",
    rx: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 19.683,
    y: 9.211,
    fill: "currentColor",
    rx: 0.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 4.017,
    y: 14.489,
    fill: "currentColor",
    rx: 0.8
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 9.239,
    y: 14.489,
    fill: "currentColor",
    rx: 0.8
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 14.461,
    y: 14.489,
    fill: "currentColor",
    rx: 0.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 19.683,
    y: 14.489,
    fill: "currentColor",
    rx: 0.8
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 4.017,
    y: 19.767,
    fill: "currentColor",
    rx: 0.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 9.239,
    y: 19.767,
    fill: "currentColor",
    rx: 0.8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 14.461,
    y: 19.767,
    fill: "currentColor",
    rx: 0.8
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 3.3,
    x: 19.683,
    y: 19.767,
    fill: "currentColor",
    rx: 0.8
  })));
};
export default SvgDiscipline4By4Icon;